import { render, staticRenderFns } from "./AidocLogin.vue?vue&type=template&id=99894e82&scoped=true"
import script from "./AidocLogin.vue?vue&type=script&lang=js"
export * from "./AidocLogin.vue?vue&type=script&lang=js"
import style0 from "./AidocLogin.vue?vue&type=style&index=0&id=99894e82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99894e82",
  null
  
)

export default component.exports